// extracted by mini-css-extract-plugin
export default {"loadercont":"Loader2_loadercont__xrQoh","loader":"Loader2_loader__Q7Gr0","l27":"Loader2_l27__nshPO"};